import {api} from '~/ViewInvitation/api/api';

export const contentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAds: builder.query({
      query: (id) => ({url: `/ajax/content/ads/${id}`}),
      providesTags: (result, error, id) => [{type: 'Event', id}],
    }),
  }),
});

export const {useGetAdsQuery} = contentApi;
